import { COLORS, Typography } from '@musinsa/mds';
import styled from 'styled-components';

import type { GiftDetail } from '@/shared/@types';
import type { FC } from 'react';

type GiftInfoProps = {
  giftDetail: Pick<GiftDetail, 'giftName' | 'stock' | 'startDateTime' | 'endDateTime'>;
};

const GiftInfo: FC<GiftInfoProps> = ({ giftDetail }) => {
  const { giftName } = giftDetail;

  return (
    <S.Container>
      <S.Title>
        <Typography variant="title18pxSemi" colorScheme="black">
          {giftName}
        </Typography>
      </S.Title>
    </S.Container>
  );
};

const S = {
  Container: styled.section`
    /* padding: 20px 16px; */
    background-color: ${COLORS.white};
  `,
  Title: styled.h1`
    padding: 24px 16px 4px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  `,
  InfoRow: styled.div`
    display: flex;
    align-items: flex-start;
    padding: 8px 0;
  `,
  InfoLabel: styled.div`
    flex-shrink: 0;
    width: 80px;
  `,
  InfoValue: styled.div`
    flex: 1;
  `,
};

export { GiftInfo };
